export enum FormOption {
  CHOOSE_ALTERNATIVE = 'choose_alternative',
  CHOOSE_DELETE = 'choose_delete',
}
